(function () {
    'use strict';

    class LeadsInsightsTitleController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            Enums
        ) {
            super($scope, $injector);
            this.__objectType = 'LeadsInsightsTitleController';

            this.LOCKED = Enums.leadsInsightsStates.locked;
            this.COLLECTING = Enums.leadsInsightsStates.collecting;
            this.RESULTS = Enums.leadsInsightsStates.results;
        }
    }

    Components.LeadsInsightsTitle = {
        bindings: {
            expanded: "<",
            onVisibilityToggle: "<",
            state: "<",
            navigateToContactForm: '&'
        },
        controller: LeadsInsightsTitleController,
        templateUrl: 'angular/app/modules/core/features/pipeline/leads_insights/leads_insights_title_template.html',
    };

}());